import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableHead, TableCell } from '@material-ui/core';

import { FeedKey } from 'api';
import { ContentProvider } from 'providers';
import { EmptyState, ResponsiveTable } from 'components';
import { ShareButton } from 'features/content/widgets';
import { useCurrentUser, useGetFeed } from 'hooks';
import { DEFAULT_SORT } from 'app-constants';

import DateCell from './Cells/Date';
import ImageCell from './Cells/Image';
import PostCell from './Cells/Post';
import StatCell from './Cells/Stat';
import { RowHead, RowBody } from './TableRow';
import ListLoader from '../ListLoader';

/**
 * TODO: Pagination for this query is busted server-side
 * offset param isn't respected
 */
const MyPosts: FC = () => {
  const currentUser = useCurrentUser();
  const { t } = useTranslation();

  const variables = {
    sort: DEFAULT_SORT,
    key: FeedKey.User,
    id: currentUser.id,
    limit: 10,
  };

  const { results, isEmpty, isInitialLoad } = useGetFeed(variables);

  if (isInitialLoad) {
    return <ListLoader />;
  }

  if (isEmpty) {
    return <EmptyState name="myPosts" />;
  }

  return (
    <ResponsiveTable>
      <Table>
        <TableHead>
          <RowHead>
            <TableCell size="small" colSpan={3}>
              {t('sharing:postedOn')}
            </TableCell>
            <TableCell size="small">{t('common:like_plural')}</TableCell>
            <TableCell size="small">{t('common:comment_plural')}</TableCell>
            <TableCell size="small">{t('common:share_plural')}</TableCell>
            <TableCell />
          </RowHead>
        </TableHead>
        <TableBody>
          {results.map(content => (
            <RowBody key={content.content_id}>
              <DateCell time={content.publish_at} />
              <ImageCell content={content} />
              <PostCell content={content} />
              <StatCell value={content.reaction_count} />
              <StatCell value={content.comment_count} />
              <StatCell value={content.share_count} />
              <TableCell>
                <ContentProvider value={{ content }}>
                  <ShareButton size="small" />
                </ContentProvider>
              </TableCell>
            </RowBody>
          ))}
        </TableBody>
      </Table>
    </ResponsiveTable>
  );
};

export default MyPosts;
